import { render, staticRenderFns } from "./OccupancyRoomsGeneral.vue?vue&type=template&id=d1b6500a"
import script from "./OccupancyRoomsGeneral.vue?vue&type=script&lang=js"
export * from "./OccupancyRoomsGeneral.vue?vue&type=script&lang=js"
import style0 from "./OccupancyRoomsGeneral.vue?vue&type=style&index=0&id=d1b6500a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports